import { CoreIcon } from '@woolworthslimited/core-components-react/icon';
import { CoreTagProps } from '@woolworthslimited/core-components-react/shared/types/tag.types';
import { FeatureTagZone } from '@woolworthslimited/core-components-react/tag-zone/tag-zone';
import { MultiBuyPriceProps } from '@woolworthslimited/core-components-react/tag-zone/tag-zone.types';
import Link from 'next/link';

import styles from './cart-product-details.module.scss';

interface CartProductDetailsProps {
  description: string;
  tagZone: {
    promotionLabel?: CoreTagProps[];
    promotionLink?: MultiBuyPriceProps[];
  };
  memberPrice?: string;
  memberPriceQuantity: string;
  memberPriceLink?: string;
  href: string;
}

export const CartProductDetails = ({
  description,
  tagZone,
  memberPrice,
  memberPriceQuantity,
  memberPriceLink,
  href,
}: CartProductDetailsProps) => (
  <span className={styles.productDetails}>
    {tagZone?.promotionLabel && (
      <FeatureTagZone
        type="promotion"
        customStyles={styles.promotionLabel}
        maxTagsToShow={1}
        model={tagZone?.promotionLabel}
      />
    )}
    <Link
      prefetch={false}
      tabIndex={-1}
      className={styles.description}
      href={href}
    >
      {description}
    </Link>
    {memberPrice && (
      <span className={styles.memberPriceArea}>
        <span className={styles.memberPriceTile}>
          <CoreIcon
            name="icon-services-rewards-card-fill"
            size="small"
            ariaHidden
            appliedCssClassNames={styles.everyDayRewardsIcon}
          />
        </span>
        <span className={styles.memberPrice}>
          <Link prefetch={false} href={memberPriceLink ?? ''}>
            <span aria-hidden>
              Member Price {memberPriceQuantity} for {memberPrice}
            </span>
            <span className="sr-only">
              view multibuy items {memberPriceQuantity} for {memberPrice}
            </span>
          </Link>
        </span>
      </span>
    )}
    {tagZone?.promotionLink && (
      <FeatureTagZone
        type="promotionLink"
        maxTagsToShow={1}
        model={tagZone.promotionLink}
      />
    )}
  </span>
);
